<template>
  <div>
  <v-dialog v-model="visible" max-width="900px" persistent>
    <v-card>
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>
          <v-icon left>mdi-folder-law</v-icon>
          {{ newCase.id ? 'Edit Case:' : 'New' }} {{ isRAF ? ' RAF Claim' : ' Case' }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>

      <v-card-text class="pt-6">
        <v-form ref="caseForm" v-model="valid">
          <v-row class="mb-4" justify="center">
            <v-col cols="12" class="text-center">
              <v-btn-toggle v-model="caseCategory" mandatory color="primary">
                <v-btn value="normal">General Litigation</v-btn>
                <v-btn value="raf">Road Accident Fund (RAF)</v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" md="6" v-if="newCase.internalRef">
              <v-text-field
                v-model="newCase.internalRef"
                label="Internal Ref"
                outlined dense readonly background-color="grey lighten-4"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" v-if="newCase.invoice_no">
              <v-text-field
                v-model="newCase.invoice_no"
                label="Invoice Number"
                outlined dense readonly background-color="grey lighten-4"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <AutoCompleteCrudAdvanced table="clients" label="Select Applicant" @input="getSelectedClient"></AutoCompleteCrudAdvanced>
              <!-- <v-select
                v-model="selectedClient"
                :items="clients"
                label="Select Client"
                outlined dense required
                :rules="[v => !!v || 'Client selection is required']"
                @change="getSelectedClient"
                return-object
              ></v-select> -->
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="newCase.respondent"
                label="Respondent [Optional]"
                outlined
                 dense 
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="newCase.sapsCaseNo"
                label="SAPS Case Number [Optional]"
                outlined dense
              ></v-text-field>
            </v-col>

            

            <v-col cols="12" md="4">
              <v-text-field
                v-model="newCase.courtCaseNo"
                label="Court Case Number [Optional]"
                outlined dense
                placeholder="e.g. 12345/2026"
              ></v-text-field>
            </v-col>

            <!-- <v-col cols="12" md="4">
              <AutoCompleteCrudAdvanced table="case_statuses" label="Case Status [Optional]" @input="getSelectedStatus"></AutoCompleteCrudAdvanced>
            </v-col> -->

            <v-col cols="12" md="4">
              <v-text-field
                v-model.number="newCase.trustBalance"
                label="Initial Trust Deposit [Optional]"
                prefix="R"
                type="number"
                outlined dense
              ></v-text-field>
            </v-col>

            <template v-if="isRAF">
              <!-- <v-col cols="12" md="4">
                <v-text-field
                  v-model="newCase.sapsCaseNo"
                  label="SAPS CAS Number [Optional]"
                  outlined dense
                ></v-text-field>
              </v-col> -->
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="newCase.instruction_date"
                  label="Instruction Date [Optional]"
                  type="date"
                  outlined dense
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" md="4">
                <v-text-field
                  v-model="newCase.prescriptionDate"
                  label="Prescription Date [Optional]"
                  type="date"
                  outlined dense
                  persistent-hint
                  hint="Automatic: Incident Date + 3 Years"
                ></v-text-field>
              </v-col> -->
              <!-- <v-col cols="12">
                <v-text-field
                  v-model="newCase.accidentLocation"
                  label="Incident Location [Optional]"
                  outlined dense
                ></v-text-field>
              </v-col> -->
            </template>

            <v-col cols="12">
              <v-textarea
                v-model="newCase.meritsSummary"
                label="Merits Summary / Internal Notes [Optional]"
                outlined
                rows="3"
                placeholder="Briefly describe the cause of action..."
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="close">Cancel</v-btn>
        <v-btn color="primary" :disabled="!valid" @click="saveCase" elevation="2">
          <v-icon left>mdi-content-save</v-icon> 
          {{ newCase.id ? 'Update Case' : 'Create Case' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import AutoCompleteCrudAdvanced from "@/modules/CrudDatabases/AutoCompleteCrudAdvanced.vue"

export default {
  name: "CaseManagementDialog",
  props: {
    value: Boolean,
    editData: { type: Object, default: null } // Pass existing case here for editing
  },
  components:{
     AutoCompleteCrudAdvanced
  },
  computed: {
    visible: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); }
    },
    isRAF() { return this.caseCategory === 'raf'; },
    getAccessToken() { return this.$store.getters.getAccessToken; },
    getThemeColor() { return this.$store.getters.getThemeColor; }
  },
  watch: {
    // If editData is passed, populate the form
    editData: {
      immediate: true,
      handler(val) {
        if (val) this.populateForm(val);
      }
    }
  },
  data() {
    return {
      openNewClientDialog:false,
      valid: false,
      caseCategory: 'normal',
      selectedClient: null,
      clients: [],
      statusOptions: [
        'New Instruction', 
        'Consultation Stage', 
        'Summons Issued', 
        'Trial Stage', 
        'Settlement Pending',
        'Finalized'
      ],
      newCase: {
        id: null,
        internalRef: '',
        invoice_no: '',
        clientRef: '',
        applicant: '',
        respondent: '',
        courtCaseNo: '',
        sapsCaseNo: '',
        status: 'New Instruction',
        prescriptionDate: '',
        instruction_date: '',
        accidentLocation: '',
        meritsSummary: '',
        trustBalance: 0,
        documents: [],
        billingEntries: [],
        tasks: [],
        chronology: []
      }
    };
  },
  methods: {
    getSelectedStatus(statusObj){
      this.newCase.status = statusObj.name
    },
    getSelectedClient(selectedClient){
      this.selectedClient = selectedClient
      this.selectedClient.applicant = selectedClient.name
      this.selectedClient.clientRef = selectedClient.client_reference
    },
    onAccidentChange(date) {
      if (date && this.isRAF) {
        let d = new Date(date);
        d.setFullYear(d.getFullYear() + 3);
        this.newCase.prescriptionDate = d.toISOString().substr(0, 10);
      }
    },
    populateForm(data) {
      this.newCase = { ...this.newCase, ...data };
      this.caseCategory = data.instruction_date ? 'raf' : 'normal';
      this.selectedClient = this.clients.find(c => c.clientRef === data.clientRef) || null;
    },
    resetForm() {
      this.caseCategory = 'normal';
      this.selectedClient = null;
      this.newCase = {
        id: null,
        internalRef: '',
        invoice_no: '',
        clientRef: '',
        applicant: '',
        respondent: '',
        courtCaseNo: '',
        sapsCaseNo: '',
        status: 'New Instruction',
        prescriptionDate: '',
        instruction_date: '',
        accidentLocation: '',
        meritsSummary: '',
        trustBalance: 0,
        documents: [],
        billingEntries: [],
        tasks: [],
        chronology: []
      };
      if (this.$refs.caseForm) this.$refs.caseForm.resetValidation();
    },
    close() {
      this.visible = false;
      this.resetForm();
    },
    closeClientDialog(){
      this.openNewClientDialog = false
    },
    async saveCase() {
      if (this.$refs.caseForm.validate()) {
        this.$store.commit("setLoader", true);

        // Map selection to payload
        const payload = { ...this.newCase };
        payload.clientRef = this.selectedClient ? this.selectedClient.clientRef : '';
        payload.applicant = this.selectedClient ? this.selectedClient.name : '';

        // Handle RAF logic
        // if (!this.isRAF) {
        //   payload.instruction_date = null;
        //   payload.prescriptionDate = null;
        // }

        try {
          const res = await axios.postDataWithToken("/auth/save-or-edit-case", payload, this.getAccessToken);
          this.$store.commit("setLoader", false);

          if (res && res.status === "success") {
            this.$toast.success(res.message);
            this.$emit('case-added', res.case);
            this.close();
          } else {
            this.$toast.error(res.message || "Operation failed");
          }
        } catch (err) {
          this.$store.commit("setLoader", false);
          this.$toast.error("Network or Authorization Error");
          console.error(err);
        }
      }
    }
  }
};
</script>